<template>
    <div id="step-1" class="step step-1" :class="{active: activeStep == 1}">

        <mu-paper class="alert-balance" :z-depth="1" v-if="getBalanceByService <= 0 && isCompanyPrepaid && activeStep == 1">
            <div class="alert-content">
                <div class="icon-alert">
                    <font-awesome-icon icon="exclamation-triangle" size="3x" :style="{ color: '#ffbc33' }" />
                </div>
                <div class="text-alert">
                    <span>Atenção</span>
                    <p>Você selecionou o tipo de mensagem <b>"{{ getServiceName(form.type_message) }}"</b> e você não possui créditos para esse serviço.</p>
                </div>
            </div>
        </mu-paper>

        <div class="number">{{ step }}</div>
        <div class="title">{{ title }}</div>

        <mu-paper class="content" :z-depth="1">

            <!-- Caso for envio para um cliente tem um campo para selecionar os clientes  -->
            <div v-if="isZiad()">
                <mu-form-item prop="checkbox">
                    <mu-checkbox v-model="form.for_client" label="Criar uma campanha para um cliente?" @change="changeClientId()"></mu-checkbox>
                </mu-form-item>
                <div v-if="form.for_client">
                    <mu-select label="Selecione o Cliente *" filterable no-data-text="Nenhum cliente encontrado" v-model="form.client_id" full-width @change="changeClientId()">
                        <mu-option v-for="(option, key) in options.clients" :key="key" :label="option.nick_name" :value="option.id"></mu-option>
                    </mu-select>
                </div>
            </div>

            <mu-text-field v-model.trim="form.title" label="Título da campanha *" full-width></mu-text-field>

            <!-- Digite a mensagem e escolha o tipo da mensagem -->
            <mu-row gutter>
                <mu-col span="12" lg="6" sm="6">
                    <mu-select label="Tipo da Mensagem *" v-model.trim="form.type_message" full-width @change="defaultMessage">
                        <mu-option v-for="(option, key) in options.channels" :key="key" :label="option.services.name" :value="option.services.id"></mu-option>
                    </mu-select>
                </mu-col>
                <mu-col span="12" lg="6" sm="6">
                    <mu-select label="Centro de Custo" v-model="form.cost_center" full-width>
                        <mu-option v-for="(option, key) in options.cost_center" :key="key" :label="option.name" :value="option.id"></mu-option>
                    </mu-select>
                </mu-col>
            </mu-row>

            <!-- Escolher entre uma nova mensagem ou mensagem padrão -->
            <mu-form-item>
                <mu-radio v-model="form.selected_type" value="new_message" label="Nova Mensagem" @click="formMessageSlug"></mu-radio>
                <mu-radio v-model="form.selected_type" value="default_message" label="Mensagem Padrão" @click="formMessageSlug"></mu-radio>
            </mu-form-item>

            <div v-if="form.selected_type == 'default_message'">

                <!-- Selecionar a mensagem padrão -->
                <mu-select label="Mensagem Padrão *" v-model="form.default_message" full-width @change="defaultMessage">
                    <mu-option v-for="(option, key) in options.default_message" :key="key" :label="option.description" :value="option.id"></mu-option>
                </mu-select>

                <!-- Mensagem escolhida  -->
                <mu-form-item prop="textarea" label="Mensagem Escolhida">
                    <mu-text-field multi-line :rows="4" :rows-max="4" disabled v-model="form.default_message_description"></mu-text-field>
                </mu-form-item>
            </div>

            <!-- Campo para digitar a nova mensagem -->
            <mu-form-item prop="textarea" label="Mensagem *" v-if="form.selected_type == 'new_message'">
                <mu-text-field v-if="routeName !== 'app.services.sms.create.variables'" multi-line :rows="4" :rows-max="4" v-model="form.message" :help-text="`Você já digitou ${countChars(form.message)} caracteres`" v-on:keyup="formMessageSlug" @change="formMessageSlug"></mu-text-field>
                <mu-textarea-variable v-else :message="form.message" v-on:sendMessage="getMessage" :typeMessage="form.type_message"></mu-textarea-variable>
            </mu-form-item>

            <div v-if="countChars(form.selected_type == 'new_message' ? form.message : form.default_message_description) > 160" class="alert-limit-characters">
                <font-awesome-icon icon="exclamation-triangle" /> A mensagem contém mais de 160 caracteres. {{ countCredits(form.selected_type === 'new_message' ? form.message : form.default_message_description) }} créditos serão consumidos para cada contato.
            </div>

        </mu-paper>
        <mu-paper class="buttons" :z-depth="1">
            <mu-flex justify-content="center" align-items="center">
                <mu-button round @click="validateMessage()" color="primary" :disabled="getBalanceByService <= 0 && isCompanyPrepaid">
                    Próximo
                    <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                </mu-button>
            </mu-flex>
        </mu-paper>
    </div>
</template>

<script>
    import MessageDefaultServices from '@/services/settings/message-default'
    import ChannelsServices from '@/services/settings/channels-clients'
    import ClientsServices from '@/services/settings/clients'
    import CostsServices from '@/services/settings/costs'
    import CampaignsServices from '@/services/services/sms'
    import BalanceServices from '@/services/dashboards/balance'

    export default {
        name: 'campaign-step-message',
        props: ['activeStep', 'step', 'title', 'form'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    channels: [],
                    clients: [],
                    cost_center: [],
                    default_message: []
                },
                balances: {
                    loading: false,
                    list: []
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Retorna os dados da empresa gravados no state
             */
            company () {
                return this.$store.state.company
            },

            routeName () {
                return this.$route.name
            },

            /**
             * Encontrando o serviço selecionado e retornando o saldo dele
             */
            getBalanceByService () {
                let find = this.balances.list.find((item) => {
                    return item.service_id === this.form.type_message
                })
                return find ? find.balance : 0
            },

            /**
             * Trás os dados da empresa gravadas no state
             */
            isCompanyPrepaid () {
                return this.$store.state.company.signatureType === 'P' || this.$store.state.company.signatureType === 'T'
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            try {
                this.$eventHub.$emit('loading', true, 'Aguarde... Carregando configurações...')

                // Dados necessários para criação da campanha
                await this.loadBalances()
                await this.loadMessageDefault()
                await this.loadChannels()
                await this.loadCosts()

                // Se a empresa logada for a ziad carregamos os clientes
                if (this.isZiad()) {
                    await this.loadClients()
                }
            } catch (e) {
                this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar.')
            } finally {
                this.$eventHub.$emit('loading', false)
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            /**
             * É acionado quando um evento sendMessage for executado no <mu-textarea-variable>
             */
            getMessage (message) {
                this.form.message = message
            },

            /**
             * Encontrando o nome do serviço
             */
            getServiceName (serviceId) {
                let find = this.options.channels.find((item) => {
                    return item.services.id === serviceId
                })
                return find ? find.services.name : ''
            },

            /**
             * Chamando o emit para dar sequência no cadastro
             */
            handleNext () {
                this.$emit('handleNext', this.form)
            },

            /**
             * Carrega o saldo da empresa
             */
            async loadBalances (query) {
                try {
                    let result = await BalanceServices.balances(query)
                    if (result && result.status) {
                        this.balances.list = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo da empresa.')
                }
            },

            /**
             * Carrega as mensagens padrões
             */
            async loadMessageDefault (query) {
                try {
                    let result = await MessageDefaultServices.findAll(query)
                    if (result && result.status) {
                        this.options.default_message = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar as mensagens padrão.')
                }
            },

            /**
             * Carrega a lista de clientes
             */
            async loadClients () {
                try {
                    let result = await ClientsServices.all()
                    if (result && result.status) {
                        this.options.clients = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar a lista de clientes.')
                }
            },

            /**
             * Carrega a lista de canais
             */
            async loadChannels (query) {
                try {
                    let result = await ChannelsServices.findAll(query)
                    if (result && result.status) {
                        this.options.channels = result.results
                        // Selecionamos o primeiro serviço automaticamente
                        if (this.options.channels.length > 0) {
                            this.form.type_message = this.options.channels[0].services.id
                        }
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os canais.')
                }
            },

            /**
             * Carrega o centro de custos
             */
            async loadCosts (query) {
                try {
                    let result = await CostsServices.all(query)
                    if (result && result.status) {
                        this.options.cost_center = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os centros de custo.')
                }
            },

            /**
             * Busca a mensagem padrão na lista para popular o textarea
             */
            async defaultMessage () {
                try {
                    // this.verifyCreditType()

                    let find = await this.options.default_message.find((item) => {
                        return item.id === this.form.default_message
                    })
                    if (this.form.selected_type === 'new_message') {
                        this.formMessageSlug()
                    }
                    if (!find) {
                        return
                    }
                    if (this.form.type_message === 4) {
                        this.form.default_message_description = find.message || ''
                    } else {
                        this.form.default_message_description = find.finalmessage || ''
                    }
                    return
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível encontrar a descrição da mensagme padrão.')
                }
            },

            /**
             * Controle para ver se a ziad está criando uma campanha para um cliente
             * nesse caso devemos carregar as configurações dos clientes
             */
            async changeClientId () {
                if (this.isZiad()) {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Carregando configurações...')
                    if (!this.form.for_client) {
                        this.form.client_id = ''
                    }
                    let query = { client_id: this.form.client_id }
                    await this.loadBalances(query)
                    await this.loadMessageDefault(query)
                    await this.loadChannels(query)
                    await this.loadCosts(query)
                    this.form.cost_center = ''
                    this.form.default_message = ''
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Formata a mensagem removendo caracteres especiais, etc...
             */
            formMessageSlug () {
                if (this.form.type_message === 4) {
                    return
                }
                this.form.message = this.strSlug(this.form.message)
            },

            /**
             * Faz uma validação da mensagem e primeira etapa
             */
            async validateMessage () {
                try {
                    if (!this.form.title) throw new Error('O título da campanha é obrigatório.')
                    if (!this.form.type_message) throw new Error('O tipo da mensagem é obrigatório.')
                    if (this.form.selected_type === 'default_message') {
                        if (!this.form.default_message) throw new Error('A mensagem padrão é obrigatório.')
                    } else {
                        let message = this.form.message.replace(/^\s+|\s+$/g, '')
                        if (!this.form.message || message === '') throw new Error('A mensagem é obrigatório.')
                    }
                    if (this.form.for_client && !this.form.client_id) throw new Error('O cliente é um campo obrigatório.')
                    let data = {
                        message: this.form.message,
                        company_id: (this.form.client_id ? this.form.client_id : this.company.id)
                    }
                    let result = await CampaignsServices.validateMessage(data)
                    if (!result.status) throw new Error(result.message || 'A mensagem não foi validada.')
                    this.handleNext()
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message, false)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .step-1
        .mu-form-item
            margin-bottom 0

    .alert-limit-characters
        margin-top 10px
        padding 8px
        border-radius 4px
        font-size 11px
        background lighten($red, 80%)
        color darken($red, 10%)

</style>
